import { createSelector } from '@ngrx/store';

import { IClientLogoUrl } from '../../models';
import { selectLogoUrl } from './content.reducers';

/**
 * Selector to determine if the client logo is loading (waiting response from the backend)..
 */
export const selectClientLogoIsLoading = createSelector(selectLogoUrl, (logo: IClientLogoUrl): boolean => logo.loading);
